import { Stack } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import routes from '@routes';
import { AccessRequestForm } from '../organisms/AccessRequestForm';
import AccessRequestFormWithTemplate from '@NewRequest/organisms/AccessRequestFormWithTemplate';

const TEMPLATE_ID_QUERY_PARAM = 'template';
export default function NewRequestPage() {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get(TEMPLATE_ID_QUERY_PARAM) || '';
  const navigate = useNavigate();

  return (
    <Stack spacing={2} maxWidth="42rem">
      {templateId ? (
        <AccessRequestFormWithTemplate templateId={templateId} />
      ) : (
        <AccessRequestForm onSuccess={() => navigate(routes.OpenRequests.path)} templatesEnabled />
      )}
    </Stack>
  );
}
